import { createElement, PropsWithChildren, useMemo } from "react";
import { MainBanner, MainBannerProps } from "./main-banner";
import { useMunicipalityHome } from "../../providers/municipality-home-provider";

const images: string[] = [
  `${process.env.PUBLIC_URL}/images/banners/1.jpg`,
  `${process.env.PUBLIC_URL}/images/banners/2.jpg`,
  `${process.env.PUBLIC_URL}/images/banners/3.jpg`,
  `${process.env.PUBLIC_URL}/images/banners/4.jpg`,
];

export const MainBannerContainer = ({ children }: PropsWithChildren<{}>) => {
  const { bannerUrl, bannerLoading, isMunicipalityHome } =
    useMunicipalityHome();
  const index = useMemo(
    () => Math.floor(Math.random() * (images.length - 1)) + 1 - 1,
    []
  );

  if (bannerLoading) return null;

  const props: MainBannerProps = {
    imageBanner: bannerUrl || images[index],
    isMunicipalityHome,
  };

  return createElement(MainBanner, props, children);
};
